export default __webpack_public_path__ + "imgs/fd895ec2adc11a29f705dd1e5599a2b1.png";